// Headset or phone. Both say yes to WebXR: Chrome on Android reports
// immersive-vr (for a cardboard viewer) and, with ARCore, immersive-ar, so a
// support check alone took every Android phone for a headset. From 28
// October to 1 November 2026, 1,307 Android users were shown the headset
// invitation ("You're browsing in a headset"), against 48 on Quest and Pico.
//
// A phone or tablet is an Android browser that names no headset, in its user
// agent (the Quest and Pico browsers do) or in its form factors (Chrome's
// client hint says XR on a headset). Everything else that can enter VR is
// taken for a headset: Quest and Pico (X11 Linux user agents), Vision Pro
// (Safari's Mac user agent), a computer with a headset plugged in. iPhones
// and iPads have no WebXR, so they never get this far.
//
// Phones get no VR offer anywhere (src/main.js setupWebXR, src/xr/invite.js,
// the home page's headset line in scripts/build-landing.js). The two
// functions below are plain ES5 because the home page inlines their source.

// ua: navigator.userAgent; formFactors: the client hint's list, or null
// where the browser cannot say.
export function phoneOrTablet(ua, formFactors) {
  ua = ua || '';
  var hints = formFactors || [];
  if (/OculusBrowser|PicoBrowser|Wolvic|\bQuest\b|\bPico\b|VR Safari/i.test(ua)) return false;
  if (hints.indexOf('XR') !== -1) return false;
  if (hints.indexOf('Mobile') !== -1 || hints.indexOf('Tablet') !== -1) return true;
  return /Android/i.test(ua);
}

// The browser's form factors (Chrome 123 on), or null. Resolves within a
// second whatever happens.
export function readFormFactors(nav) {
  var uad = nav && nav.userAgentData;
  if (!uad || typeof uad.getHighEntropyValues !== 'function') return Promise.resolve(null);
  var asked = uad.getHighEntropyValues(['formFactors']).then(function (v) {
    var f = v && v.formFactors;
    return Array.isArray(f) ? f : (typeof f === 'string' ? [f] : null);
  }).catch(function () { return null; });
  var late = new Promise(function (resolve) { setTimeout(function () { resolve(null); }, 1000); });
  return Promise.race([asked, late]);
}

let answer = null;
// Whether this browser is on a phone or tablet, asked once.
export function onPhoneOrTablet() {
  if (!answer) {
    answer = typeof navigator === 'undefined'
      ? Promise.resolve(false)
      : readFormFactors(navigator).then((f) => phoneOrTablet(navigator.userAgent, f));
  }
  return answer;
}
